import { UserRole } from '../../enums/UserRole'
import { SidebarItemsType } from '../../types/sidebar'
import { Briefcase, Users, Home, Cpu, Zap } from 'react-feather'
import {
  Add,
  Build,
  Business,
  Hvac,
  DeviceThermostat,
  SwapHoriz,
  Analytics
} from '@mui/icons-material'
import CampaignIcon from '@mui/icons-material/Campaign'
import { SidebarTitle } from '../../enums/SidebarTitle'

const pagesSection = [
  {
    roles: [
      UserRole.SUPERADMIN,
      UserRole.INSTALLER,
      UserRole.ADMIN,
      UserRole.USER,
      UserRole.MANUFACTURER,
      UserRole.GUEST
    ],
    href: '/',
    icon: Home,
    title: SidebarTitle.FRONTPAGE
  },

  {
    roles: [
      UserRole.SUPERADMIN,
      UserRole.INSTALLER,
      UserRole.ADMIN,
      UserRole.USER,
      UserRole.MANUFACTURER,
      UserRole.GUEST
    ],
    href: '/projects',
    icon: Business,
    title: SidebarTitle.PROJECTS
  },

  {
    roles: [UserRole.SUPERADMIN],
    href: '/powersupplies',
    icon: Zap,
    title: SidebarTitle.POWERSUPPLIES
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/heaters',
    icon: Hvac,
    title: SidebarTitle.HEATERS
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/ruuvi-tags',
    icon: DeviceThermostat,
    title: SidebarTitle.CONDITION_MONITORING
  },

  {
    roles: [UserRole.SUPERADMIN],
    href: '/devices',
    icon: Cpu,
    title: SidebarTitle.DEVICES
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/companies',
    icon: Briefcase,
    title: SidebarTitle.COMPANIES
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/users',
    icon: Users,
    title: SidebarTitle.USERS
  },
  {
    roles: [UserRole.SUPERADMIN, UserRole.MANUFACTURER],
    href: '/manufacturing',
    icon: Build,
    title: SidebarTitle.MANUFACTURING
  },
  {
    roles: [UserRole.SUPERADMIN, UserRole.INSTALLER, UserRole.ADMIN, UserRole.USER],
    href: '/install',
    icon: Add,
    title: SidebarTitle.INSTALL_NEW_DEVICE
  },
  {
    roles: [
      UserRole.SUPERADMIN,
      UserRole.ADMIN,
      // UserRole.USER,
      UserRole.INSTALLER
    ],
    href: '/devices/replace',
    icon: SwapHoriz,
    title: SidebarTitle.REPLACE_DEVICE
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/announcements',
    icon: CampaignIcon,
    title: SidebarTitle.ANNOUNCEMENT_MANAGEMENT
  },
  {
    roles: [UserRole.SUPERADMIN],
    href: '/analytics',
    icon: Analytics,
    title: SidebarTitle.ANALYTICS
  }
] as SidebarItemsType[]

const navItems = [
  {
    // title: 'Pages',
    pages: pagesSection
  }
]

export default navItems
